export const environment = {
  production: true,
  development: false,
  staging: false,
  version: 'v1',

  //noblaa
  basicUrl: 'https://gateway.nobala.edu.sa/api',
  staffUrl: 'https://abnayiy.nobala.edu.sa/',
  parentUrl: 'https://parent.nobala.edu.sa/',
  teacherUrl: 'https://teacher_portal.nobala.edu.sa/',
  studentUrl: 'https://student_portal.nobala.edu.sa/',
  dmUrl: 'https://dm.nobala.edu.sa/',
  sponsorUrl: 'https://sponsor_portal.nobala.edu.sa/',

  //ajial
  //basicUrl: 'https://gateway-ajial.abnaey.com/api',
  
  mapsApiKey: 'AIzaSyDZsQEDaOUzZC69BShQQUTW_x_dVVHXO8Y',
};
